import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ResponsiveValue,
  useToast,
} from '@chakra-ui/react';
import { removeAccount } from '@partiu/api/user/api';
import { useMutation } from 'react-query';

export function DeleteAccountModal<T>({
  onClose,
  isOpen,
}: {
  onClose: () => void;
  isOpen: boolean;
  instance?: T;
  size?: ResponsiveValue<string>;
}) {
  const toast = useToast();

  const removeMutation = useMutation(() => removeAccount(), {
    onSuccess() {
      localStorage.removeItem('user');
      window.location.reload();
    },
    onError() {
      toast({
        title: 'Não foi possível apagar seus dados.',
        description:
          'Entre em contato conosco pelo email suporte@partiu.com.br para pedir sua remoção de dados. O prazo máximo é de cinco dias úteis.',
      });
    },
  });

  return (
    <Modal isOpen={isOpen}  onClose={onClose}>
      <ModalOverlay backdropFilter={'blur(5px)'} />
      <ModalContent paddingBottom={'15px'}>
        <ModalHeader>Tem certeza?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Essa ação apagará todos os dados relacionados a sua conta em nosso banco de dados, inclusive seu acesso aos
          clubes. Caso recrie sua conta, você não terá mais acesso ao Clube e deverá consultar a reativação com a sua
          empresa.
        </ModalBody>
        <ModalFooter>
          <Button variant={'ghost'} colorScheme="blue" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="red" onClick={removeMutation.mutate} ml={3}>
            Deletar meus Dados
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
